<template>
  <div class="knowledge-form">
        <b-form-group horizontal label="General information" label-size="lg" class="mb-0" label-class="font-weight-bold pt-0">
            <b-form-group horizontal label-class="text-sm-right" id="orderInputGroup" label="Process name" label-for="inputName" description="">
                <b-form-input id="inputName" type="text" v-model="form.name" required placeholder="">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="inputDescriptionGroup" label="Description" label-for="inputDescription" description="">
                <b-form-textarea id="inputDescription" type="text" v-model="form.description" rows="4"></b-form-textarea>
            </b-form-group>
        </b-form-group>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      show: true
    }
  },
  props: ['submit_handler', 'form'],
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      this.$http.post('v1/kb/1/processes', this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/kb/1/process/' + response.data.response.knowledge_process_id + '/detail');
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.name = '';
      this.form.description = '';
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    }
  }
}
</script>
